(() => {
function $e960a239a0d3cd9c$var$toggleLanguage() {
    var japaneseText = document.getElementById("japanese-text");
    var englishText = document.getElementById("english-text");
    var isChecked = document.getElementById("language-toggle").checked;
    if (isChecked) {
        japaneseText.style.display = "none";
        englishText.style.display = "block";
    } else {
        japaneseText.style.display = "block";
        englishText.style.display = "none";
    }
}
// Assign toggleLanguage to the global window object
window.toggleLanguage = $e960a239a0d3cd9c$var$toggleLanguage;
// Maybe this can fix it
const $e960a239a0d3cd9c$var$japaneseCharacters = [
    "\u4ED5\u4E8B",
    "\u58EE\u5927",
    "\u6728",
    "\u5207\u78CB\u7422\u78E8",
    "\u4F98\u5BC2",
    "\u548C"
]; // Example characters
function $e960a239a0d3cd9c$var$changeJapaneseText() {
    const randomIndex = Math.floor(Math.random() * $e960a239a0d3cd9c$var$japaneseCharacters.length);
    document.getElementById("japanese-char").textContent = $e960a239a0d3cd9c$var$japaneseCharacters[randomIndex];
}
setInterval($e960a239a0d3cd9c$var$changeJapaneseText, 100); // Adjust speed of changing Japanese characters

})();
//# sourceMappingURL=index.js.map
